import styled from 'styled-components';
import { colors } from 'styles/colors';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  text-align: left;
  margin: -4px;
  padding: 6px 4px;
`;

export const Title = styled.span`
  font-weight: 500;
  font-size: 12px;
  color: ${colors.text['white-0']};
`;

export const Factor = styled.span`
  font-weight: 600;
  font-size: 13px;
  color: ${colors.text['white-0']};
`;
